import React from 'react';
import {CLGDetalleFila} from "./SeccionCLGDatosDetalle";
import {OperacionCLGDetalleFields} from "../types/fields";
import AforoField, {FormActualizarAforo} from "./AforoField";
import {ITableGroups, TableList} from "../../../../../components/table";
import {useMediaQuery, useTheme} from "@mui/material";
import {HttpCLG} from "../api/HttpCLG";
import {EntityWithIdFields} from "../../../../../types";

interface CLGDetalleTablaProps {
    data: CLGDetalleFila[][],
    idOperacion?: number
}

function CLGDetalleTabla({data, idOperacion}:CLGDetalleTablaProps) {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));


    const onUpdateAforo = (data: FormActualizarAforo) => {
        return idOperacion && HttpCLG.putDetalle(idOperacion, data)
    }

    return (
        <div>
            {data.map((group, index) => {
                const columns: any[] = [];
                columns.push({ label: `Especie`, value: OperacionCLGDetalleFields.Especie });

                for (let i = 0; i < group[0].listaAforo.length; i++) {
                    columns.push({
                        label: `Porcentaje de Aforo`,
                        onRenderCell: (item: CLGDetalleFila) => (
                            item.listaAforo[i] ? (
                                <AforoField
                                    onUpdateAforo={onUpdateAforo}
                                    fila={item}
                                    aforo={item.listaAforo[i]}
                                    permiteEditar={item.listaAforo[i]?.[OperacionCLGDetalleFields.PermiteModificar]}
                                    iniciaEditando={!idOperacion}
                                />
                            ) : (
                                <span></span>
                            )
                        )
                    });
                }

                const gruposColumnas: ITableGroups[] = group[0].listaAforo.map((item, index) => ({
                    firstColumn: index + 1,
                    lastColumn: index + 1,
                    label: item[OperacionCLGDetalleFields.Sector]
                }));

                if (isSmallScreen) {
                    return (
                        <div key={index}>
                            {gruposColumnas.map((grupo, idx) => {
                                const columnaGrupo = {
                                    firstColumn: 0,
                                    lastColumn: 1,
                                    label: grupo.label
                                };

                                return (
                                    <TableList
                                        key={`${index}-${idx}`}
                                        entityList={group}
                                        columns={[columns[0], ...columns.slice(idx + 1, idx + 2)]}
                                        columnGroups={[columnaGrupo]}
                                        isLoading={false}
                                        error={false}
                                    />
                                );
                            })}
                        </div>
                    );
                }

                return (
                    <TableList
                        key={index}
                        entityList={group}
                        columns={columns}
                        columnGroups={gruposColumnas}
                        isLoading={false}
                        error={false}
                    />
                );
            })}
        </div>
    );
};

export default CLGDetalleTabla;